module.exports = __webpack_public_path__ + "static/media/ArrowRight.cf769981.svg";